const widgetPosition = window.parent.document.getElementById('netomiChatWindow')?.getAttribute('position') || 'right'
const widgetPositionStyle = ( 
    widgetPosition === 'right' ? 
    `position:fixed; right:10px; max-height: 704px; bottom:10px; z-index:2147483647; transition: 0.3s all ease-in-out;` :
    `position:fixed; left:10px; max-height: 704px; bottom:10px; z-index:2147483647; transition: 0.3s all ease-in-out;`
)
export default {
    SMALL_SCREEN_DEVICES: {
        height: '100%',
        width: '100%',
        style: 'position:fixed; right:0px; bottom:0px; z-index:2147483647; transition: 0.3s all ease-in-out;'
    },
    LARGE_SCREEN_DEVICES: {
        height: '90%',
        width: '386px',
        style: widgetPositionStyle
    },
    SHOW_SUPPORT_ICON_ONLY: {
        height: '68px',
        width: '70px',
        style: widgetPositionStyle
    },
    SHOW_SUPPORT_ICON_TEXT: {
        height: '68px',
        width: '290px',
        style: widgetPositionStyle
    },
    HIDE: {
        height: '0px',
        width: '0px',
        style: 'display: none;'
    }
}
